<div [style.background-image]="pageBackgroundUrl" id="wrapper" [class.mobile-mode]="isMobile" [class.booth-mode]="isBooth">
  <router-outlet />
</div>

<div id="bcw-modal-backdrop" #modal tabindex="-1" aria-hidden="true" class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
  <div class="relative p-4 w-full max-w-2xl max-h-full" id="bcw-modal">
    <!-- Modal content -->
    <div class="relative rounded-lg shadow">
      <!-- Modal header -->
      <div class="flex items-center justify-between border-b pb-3 rounded-t">
        <h3 class="text-xl font-semibold">Browser Compatability</h3>
        <button
          type="button"
          (click)="dismiss()"
          class="text-gray-400 bg-transparent rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center hover:bg-neutral-600 hover:text-white">
          <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
          </svg>
          <span class="sr-only">Close modal</span>
        </button>
      </div>
      <!-- Modal body -->
      <div class="py-3">
        <p>Your OS and Browser may not be compatible.</p>
        <p>For the best user experience, update your operating system and use Chrome or Safari to use this app.</p>
      </div>
    </div>
  </div>
</div>
